import React, { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Section from './Section'
import SectionTitle from './SectionTitle'
import ImpactStatsRow from '../impact/ImpactStatsRow'
import ImpactQuestionTable from '../impact/ImpactQuestionTable'
import ImpactComparisonBars from '../impact/ImpactComparisonBars'
import { Card } from '../ui'
import { buildCohortReport } from '../../data/demo-cohort'

/**
 * The centerpiece: the same components the impact report page renders, fed with
 * the fictional cohort. Nothing here is a screenshot.
 */
const ChangeSection: React.FC = () => {
  const intl = useIntl()
  const report = useMemo(() => buildCohortReport(intl), [intl])

  return (
    <Section id="changement">
      <SectionTitle
        title={intl.formatMessage({ id: 'marketing.change.title' })}
        subtitle={intl.formatMessage({ id: 'marketing.change.subtitle' })}
      />

      <p className="text-sm font-semibold text-foreground mb-3">{report.survey_title}</p>
      <ImpactStatsRow report={report} compact />
      <p className="mt-3 text-xs text-foreground-muted">
        <FormattedMessage id="marketing.change.excludedNote" />
      </p>

      <div className="mt-10 grid gap-8 lg:grid-cols-2">
        {/* The table needs about 700px to read; below that the bars carry the
            same numbers without a sideways scroll, so the phone gets those. */}
        <div className="hidden lg:block min-w-0">
          <h3 className="text-lg font-semibold text-foreground mb-3">
            <FormattedMessage id="marketing.change.perQuestionTitle" />
          </h3>
          <ImpactQuestionTable report={report} />
        </div>
        <div className="min-w-0">
          <h3 className="text-lg font-semibold text-foreground mb-3">
            <FormattedMessage id="marketing.change.visualTitle" />
          </h3>
          <ImpactComparisonBars report={report} />
        </div>
      </div>

      <div className="mt-10">
        <h3 className="text-lg font-semibold text-foreground mb-3">
          <FormattedMessage id="marketing.change.summaryTitle" />
        </h3>
        <Card elevated>
          <p className="text-foreground leading-relaxed">{report.summary}</p>
          <p className="text-xs text-foreground-muted mt-3">
            <FormattedMessage id="marketing.cohort.fictional" />
          </p>
        </Card>
      </div>
    </Section>
  )
}

export default ChangeSection
